import React, { Fragment, memo, useState } from 'react'
import { Table } from 'antd'
import { NoData, PageAlert, TableContainer } from 'components'
import EmptyAccountsList from 'views/UserManagement/Users/components/EmptyUsersList'
import UserListTop from 'views/UserManagement/Users/components/UserListTop'
import UserListColumns from 'views/UserManagement/Users/components/UserListColumns'
import { freeSearch } from 'utils/search'

const SEARCH_USERS_MAPPING = {
  name: 'name',
  surname: 'surname',
  email: 'email'
}

function UserList({ data, loading, error, handleInviteModalOpen, inviteUsers }) {
  const [searchData, setSearchData] = useState(data)

  const handleSearch = term => {
    if (term && term.length) setSearchData(freeSearch(searchData, term, SEARCH_USERS_MAPPING))
    else {
      setSearchData(data)
    }
  }
  return (
    <Fragment>
      {error && <PageAlert message={error} />}
      <UserListTop handleInviteModalOpen={handleInviteModalOpen} onSearch={handleSearch} />
      <TableContainer>
        {!data && !loading && <EmptyAccountsList />}
        {data && !loading && (
            <Table
            rowKey="id"
            pagination={{ hideOnSinglePage: true, pageSize: 50 }}
            columns={UserListColumns(inviteUsers)}
            dataSource={searchData || data}
            loading={loading}
            locale={{
              emptyText: <NoData />
            }}
          />
        )}
      </TableContainer>
    </Fragment>
  )
}

export default memo(UserList)
